module.exports = __webpack_public_path__ + "frontend/images/favicons/mstile-144x144.png?84a5e75c300454ae110d89e49d07624a";